export const MOBILE_BANNER_TITLE = 'Кнопка_открыть_приложение';
